import FrameTile from '@frame/Frame/FrameTile'
import { useState } from 'react'
import { View } from 'react-native'

export default function FramePage() {
  const [checked, setChecked] = useState(false)

  return (
    <View className="w-full flex-1 items-center gap-32 bg-white p-8">
      <FrameTile
        title="3U002-T002"
        type="frame"
        checked={checked}
        onPress={() => setChecked(!checked)}
        image="https://frameimage.brillen.de/GINO-5412245141748/OVERVIEW/picture.jpg"
        details={['Ray Ban', '299,00€', 'Gold']}
        variant={checked ? 'active' : 'default'}
        badge={{
          variant: 'success',
          text: 'Active',
        }}
      />
    </View>
  )
}
